/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemDescendantsDetailsSchema = z.object({
  hasChildren: z.boolean(),
  itemId: z.int(),
});
